
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { Group, GroupUser, ListItem } from '../../backend/backendapi';
import SelectModal from '../../selectmodal/selectmodal.controller';
import UsersSelectModal from './UsersSelectModal';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { paginationOptions, searchOptions } from '../../../util/vue-good-table';
import { applyGroupSelector, GroupSelector } from '../util';

type UserWithName = {
  groupUser: GroupUser;
  name: string;
}

@Component({
  components: {
    UsersSelectModal,
    VueGoodTable,
  },
})
export default class UsersEditor<T> extends Vue {
  @Prop({ required: true })
  readonly group!: T;
  @Prop({ default: '' })
  readonly groupSelector!: GroupSelector<T>;
  @Prop({ required: true })
  readonly allUsers!: ListItem[];

  get allUsersForSelectModal(): ListItem[] {
    this.extractedGroup.userIds ??= [];

    //we only what to show not linked surveys in the select modal
    const alreadyPresentUserIds = new Set(this.extractedGroup.userIds.map(e => e.userId));
    return this.allUsers.filter(e => !alreadyPresentUserIds.has(e.id!));
  }

  get columnsConfig(): any[] {
    return [{
      label: this.$t('name').toString(),
      field: (e: UserWithName) => e.name,
    }, {
      label: this.$i18n.t('general.actions').toString(),
      field: 'actions',
      width: '5em',
    }];
  }

  get extractedGroup(): Group {
    return applyGroupSelector(this.group, this.groupSelector);
  }

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  get usersById(): Map<string, ListItem> {
    return new Map(this.allUsers.map(e => [e.id!, e]));
  }

  get usersWithName(): UserWithName[] {
    this.extractedGroup.userIds ??= [];
    return this.extractedGroup.userIds.map((groupUser: GroupUser) => {
      let user = this.usersById.get(groupUser.userId);
      return {
        groupUser: groupUser,
        name: (user?.firstName ?? '') + ' ' + (user?.lastName ?? ''),
      };
    });
  }

  onRemoveUser(entry: UserWithName): void {
    this.extractedGroup.userIds ??= [];
    const index = this.extractedGroup.userIds.findIndex(e => e.userId === entry.groupUser.userId);
    if (index >= 0) {
      this.extractedGroup.userIds.splice(index, 1);
    }
  }

  onUsersSelected(users: ListItem[]): void {
    this.extractedGroup.userIds ??= [];
    this.extractedGroup.userIds.push(...users.map(u => GroupUser.fromJS({
      id: 0,
      userId: u.id,
      groupId: this.extractedGroup.id,
      addedOn: new Date(),
    })));
  }

  openSelectModal(): void {
    (this.$refs.selectModal as SelectModal<ListItem>).open();
  }
}
